const API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

const getAuthToken = () => {
    return localStorage.getItem('jwtToken');
};

const handleResponse = async (response) => {
    const contentType = response.headers.get('content-type') || '';
    const responseText = await response.text();

    if (!response.ok) {
        let errorText = 'An API error occurred.';
        if (contentType.includes('application/json')) {
            try {
                const parsed = JSON.parse(responseText);
                errorText = parsed.message || errorText;
            } catch {
                errorText = responseText || errorText;
            }
        } else {
            errorText = responseText || errorText;
        }
        throw new Error(errorText);
    }

    try {
        return JSON.parse(responseText);
    } catch {
        return { message: responseText };
    }
};

export const getAllUsers = async () => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/users`, {
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
};

export const toggleUserVerifiedStatus = async (userId, role) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/users/${role}/${userId}/toggle-verify`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
};

export const toggleUserActiveStatus = async (userId, role) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/users/${role}/${userId}/toggle-active`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
};

export const deleteUser = async (userId, role) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/users/${role}/${userId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
};

export const updateUser = async (userId, role, data) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/users/${role}/${userId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    });
    return handleResponse(response);
};

export const getAllLoads = async () => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/loads`, {
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
};

export const getAllTrucks = async () => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/trucks`, {
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
};

export const getEquipmentTypes = async () => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/equipment`, {
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
};

export const addEquipmentType = async (equipmentData) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/equipment`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(equipmentData),
    });
    return handleResponse(response);
};

export const updateEquipmentType = async (id, equipmentData) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/equipment/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(equipmentData),
    });
    return handleResponse(response);
};

export const deleteEquipmentType = async (id) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/equipment/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
};

export const getAllReviewsForAdmin = async () => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/reviews`, {
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
};

export const updateReviewStatus = async (reviewId, is_approved) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/admin/reviews/${reviewId}/status`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ is_approved }),
    });
    return handleResponse(response);
};